// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"d8c3bf1f","117":"40c2316d","239":"2c4fa357","511":"837cae78","704":"c2054cb6","726":"4cceb8c2","839":"066d1c7d","845":"8d6721aa","874":"4f7ada8c","906":"084ab9ab"}[chunkId] + ".chunk.js";
};